export enum UpsellType {
  SIZE_BASED = 'Size Based',
  INGREDIENT = 'Ingredient',
  EXTRA_INGREDIENT = 'Extra Ingredient',
}
